var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgHome28 = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 28,
  height: 28,
  viewBox: "0 0 28 28",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M14 6C14.139 6 14.2718 6.05789 14.3664 6.15977L20.8664 13.1598C20.9523 13.2523 21 13.3738 21 13.5V21.5C21 21.7761 20.7761 22 20.5 22H15.5C15.2239 22 15 21.7761 15 21.5V18H13V21.5C13 21.7761 12.7761 22 12.5 22H7.5C7.22386 22 7 21.7761 7 21.5V13.5C7 13.3738 7.04773 13.2523 7.1336 13.1598L13.6336 6.15977C13.7282 6.05789 13.861 6 14 6ZM8 13.6963V21H12V17.5C12 17.2239 12.2239 17 12.5 17H15.5C15.7761 17 16 17.2239 16 17.5V21H20V13.6963L14 7.23481L8 13.6963Z",
  fill: "currentColor"
})));
export default SvgHome28;